import { 
    SET_TOGGLE_CARD, 
    SET_TOGGLE_RANK, 
    SET_TOGGLE_CORNER, 
    SET_TOGGLE_HDC, 
    SET_TOGGLE_OU,
    SET_TOGGLE_X2,
    SET_TOGGLE_SOUND 
} from "./actionTypes"

const INITIAL_STATE = {
    card: true,
    rank: true,
    corner: true,
    hdc: true,
    ou: true,
    x2: true,
    sound: false
}

const ToggleReducer = (state: any = INITIAL_STATE, action: any) => {
    switch (action.type) {
        case SET_TOGGLE_CARD:
            return {
                ...state,
                card: action.payload
            }
        case SET_TOGGLE_RANK:
            return {
                ...state,
                rank: action.payload
            }
        case SET_TOGGLE_CORNER:
            return {
                ...state,
                corner: action.payload
            }
        case SET_TOGGLE_HDC:
            return {
                ...state,
                hdc: action.payload
            }
        case SET_TOGGLE_OU:
            return {
                ...state,
                ou: action.payload
            }
        case SET_TOGGLE_X2:
            return {
                ...state,
                x2: action.payload
            }
        case SET_TOGGLE_SOUND:
            return {
                ...state,
                sound: action.payload
            }
        default:
            return state;
    }
}

export default ToggleReducer